import React from 'react'
import { createPortal } from 'react-dom'
import { AnimatedIcon } from '@node-space/storybook-components/dist/AnimatedIcon'
import loader from '@node-space/storybook-components/dist/lottie/loader.json'
import { Box } from '@node-space/ui-components'

export const ContactsSearchListLoader = () => {
  return (
    <>
      {createPortal(
        <Box
          flexCol
          width="full"
          minHeight="screen"
          centerChildren
          gap={20}
          className="bg-[#FFFEFA]/10 shadow-lg shadow-black/10 fixed z-[80] backdrop-blur"
        >
          <Box className="-translate-y-40 transform">
            <AnimatedIcon animationData={loader} width={80} height={80} />
          </Box>
        </Box>,
        document.querySelector('[data-radix-scroll-area-viewport]')
      )}
    </>
  )
}
